module.exports = __webpack_public_path__ + "img/carline_2.d334e780.png";